/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ResearchPageFetchCall,
  ResearchPageFetchCall$inboundSchema,
} from "./researchpagefetchcall.js";
import {
  ResearchWebSearchCall,
  ResearchWebSearchCall$inboundSchema,
} from "./researchwebsearchcall.js";

/**
 * One action a research run took, named by tool and carrying the payload for that tool. The report is a synthesis that drops most of what was read; this is what the agent actually did. Observability, never a claim about the server.
 */
export type ResearchToolCall = {
  /**
   * The tool's failure text, when the call did not succeed.
   */
  error?: string | undefined;
  /**
   * A page the agent fetched, with what came back and the injection judge's verdict on it. A fetch spends nothing.
   */
  fetch?: ResearchPageFetchCall | undefined;
  /**
   * A web search the agent ran. A search runs a billed completion, so its token spend lives here.
   */
  search?: ResearchWebSearchCall | undefined;
  /**
   * Position in the run, from zero.
   */
  sequence: number;
  /**
   * The tool that ran: web_search or fetch_page. The discriminator for which payload below is present.
   */
  tool: string;
};

/** @internal */
export const ResearchToolCall$inboundSchema: z.ZodMiniType<
  ResearchToolCall,
  unknown
> = z.object({
  error: z.optional(z.string()),
  fetch: z.optional(ResearchPageFetchCall$inboundSchema),
  search: z.optional(ResearchWebSearchCall$inboundSchema),
  sequence: z.int(),
  tool: z.string(),
});

export function researchToolCallFromJSON(
  jsonString: string,
): SafeParseResult<ResearchToolCall, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResearchToolCall$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResearchToolCall' from JSON`,
  );
}
